import { Component } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";
import Base from "../Base";

export type UpdateProfilePayload = {
  id: number;
  companyPrincipalId: number;
  productPrincipalId?: number;
};

export type UpdateProfileAssociationsPayload = {
  adcontrolMatches: UpdateProfilePayload[];
};

@Component
export default class ProfileAssociationMixin extends Base {
  getProfileAssociations(slug: string, tag: string, params?: any) {
    const queryString = this.paramsToQueryString(params);
    const url =
      API_ENDPOINT + `/${slug}/agents/profiles_association.json?${queryString}`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }

  ignoreProfile(slug: string, id: string, tag: string) {
    const url =
      API_ENDPOINT + `/${slug}/agents/profiles_association/${id}/ignore.json`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "POST",
    });
  }

  updateProfileAssociations(
    slug: string,
    data: UpdateProfileAssociationsPayload,
    tag: string
  ) {
    const url =
      API_ENDPOINT + `/${slug}/agents/profiles_association/associate_many.json`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "PUT",
      data: data,
    });
  }
}
